import { useContext } from "react";
import { LogoutContext } from "./LogoutContext";
import { TLogoutContextValue } from "./LogoutContext.types";

export const useLogout = (): TLogoutContextValue => {
  const context = useContext(LogoutContext);

  if (context === undefined) {
    throw new Error("useLogout must be used within a LogoutProvider");
  }

  return context;
};
